import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import {
  BrandThemesEnum,
  IComponentWrapper,
  SdComponentWrapperComponent,
  SizesEnum
} from '@seb/web-design-system/core';
import {
  BaseComparatorComponent
} from '@seb/web-common/core/components/base/base-comparator/base-comparator.component';
import { LameConfig, WC_CONFIG_PROVIDER, WcConfig } from '@seb/web-common/core/models';
import { HeadingParagraphMapper } from '@seb/web-common/core/mappers';

@Component({
  selector: 'wc-pdp-comparator',
  templateUrl: './pdp-comparator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdComponentWrapperComponent, BaseComparatorComponent]
})
export class PdpComparatorComponent implements OnInit, OnDestroy {
  productCodes: string[];
  showTable = false;
  lameConfig: LameConfig;
  wrapperContent: IComponentWrapper;

  private readonly destroy$: Subject<void> = new Subject();
  constructor(
    private currentProductService: CurrentProductService,
    private translateService: TranslateService,
    private cdRef: ChangeDetectorRef,
    private headingParagraphMapper: HeadingParagraphMapper,
    @Inject(WC_CONFIG_PROVIDER) protected wcConfig: WcConfig
  ) {}

  ngOnInit(): void {
    this.lameConfig = this.wcConfig?.pdp?.comparator || {};
    this.currentProductService
      .getProduct()
      .pipe(
        filter((p) => !!p),
        takeUntil(this.destroy$)
      )
      .subscribe((product) => {
        const richParagraphData = {
          heading: {
            headline: this.translateService.instant('pdp.sectionTitles.comparator')
          },
          titleTheme: this.wcConfig?.pdp?.comparator?.titleTheme || BrandThemesEnum.brand,
          size: SizesEnum.l
        };
        const productCodes: string[] = [product.code];
        product.productReferences?.COMPARATOR?.forEach((accessoires) => {
          productCodes.push(accessoires.target.code);
        });
        this.productCodes = [...productCodes];
        const productClassifications = product.classifications?.filter(
          (classification) => classification.type !== 'USER_FRIENDLY'
        );
        this.showTable = productClassifications?.length > 0 && this.productCodes?.length > 1;
        this.wrapperContent = {
          titleLevel: 2,
          links: [],
          footNotes: [],
          heading: this.headingParagraphMapper.toHeadingParagraph(richParagraphData)
        };
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
